import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const getAllTeamMember = catchAsync(async () => {
  const { data } = await axiosInstance.get("salon/team-members");
  return data;
});

export const getTeamMembersLocation = catchAsync(async (locationId, params) => {
  const { data } = await axiosInstance.get(`salon/${locationId}/team-members`, {
    params,
  });
  return data;
});

export const getAvailableTeamMembersByServices = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    `salon/${body?.locationId}/appointments/available-team-members`,
    body
  );
  return data;
});

export const addTeamMember = catchAsync(async (body) => {
  const data = await axiosInstance.post(`salon/team-members`, body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return data;
});

export const updateTeamMemberImage = catchAsync(async (teamMemberId, body) => {
  const data = await axiosInstance.post(
    `salon/team-members/${teamMemberId}/update-profile-image`,
    body,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return data;
});

export const showTeamMember = catchAsync(
  async (teamMemberId, xTranslations) => {
    const { data } = await axiosInstance.get(
      `salon/team-members/${teamMemberId}`,
      {
        headers: {
          "x-translations": xTranslations,
        },
      }
    );
    return data;
  }
);

export const editTeamMember = catchAsync(async (teamMemberId, body) => {
  const { data } = await axiosInstance.post(
    `salon/team-members/${teamMemberId}`,
    body,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return data;
});

export const deleteTeamMember = catchAsync(async (teamMemberId) => {
  const { data } = await axiosInstance.delete(
    `salon/team-members/${teamMemberId}`
  );
  return data;
});

export const updateTeamMemberActiveStatus = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    `salon/team-members/update-calendar-booking`,
    body
  );
  return data;
});
